import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'app/models/user.models';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-user-profile',
  standalone: false,
  moduleId: module.id,
  templateUrl: './user-profile.component.html',
  styleUrls: [],
})
export class UserProfileComponent implements OnInit {
  currentRoute: string;
  userId: number | null = null;
  isLoading = false;
  user?: User;
  inputHasChange: boolean = true;

  userForm: FormGroup;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    const sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (sidebar !== undefined) {
      sidebar.innerHTML = 'Configuraciones';
    }
    this.initForms();
    const userUid = this.userService.getUID();
    this.loadUser(userUid);
  }

  initForms() {
    this.userForm = this.fb.group({
      name: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      username: ['', [Validators.required]],
      identificationNumber: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required]],
      rol: [{ value: '', disabled: true }, Validators.required],
    });
  }

  loadUser(userUid: string) {
    this.isLoading = true;
    this.userService.getUserByUid(userUid).subscribe({
      next: (user: User) => {
        this.userId = user.id;
        this.user = user;
        this.userForm.patchValue({
          name: user.name || '',
          lastname: user.lastname || '',
          email: user.email,
          username: user.username || '',
          identificationNumber: user?.identificationNumber,
          phoneNumber: user?.phoneNumber,
          rol: user.rol,
        });
        this.isLoading = false;
      },
      error: error => {
        console.error('Error al cargar el usuario:', error);
        this.isLoading = false;
        this.snackBar.open('Error al cargar el usuario', 'Cerrar', {
          duration: 3000,
        });
      },
    });
  }

  onChangeInput(field: string, event?) {
    let inputValue = this.userForm.get(field).value;

    if (event && event.target.files[0]) {
      inputValue = event.target.files[0].name;
    }

    inputValue !== this.user[field] ? (this.inputHasChange = false) : (this.inputHasChange = true);
  }

  submitUserForm() {
    if (this.isLoading) return;

    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched();
      return;
    }

    const userData = this.userForm.value;

    this.userService.updateUser(this.userId, userData).subscribe({
      next: () => {
        this.snackBar.open('Usuario actualizado con éxito', 'Cerrar', {
          duration: 3000,
        });
        this.router.navigate(['/configurar']);
      },
      error: error => {
        console.error('Error actualizando usuario:', error);
        this.snackBar.open('Error al actualizar el usuario', 'Cerrar', {
          duration: 3000,
        });
        this.isLoading = false;
      },
    });
  }

  cancelUserForm() {
    this.router.navigate(['/configurar']);
  }

  get emailControl() {
    return this.userForm.get('email');
  }
  get nameUserControl() {
    return this.userForm.get('name');
  }
  get lastnameControl() {
    return this.userForm.get('lastname');
  }
  get passwordControl() {
    return this.userForm.get('password');
  }
  get roleIdControl() {
    return this.userForm.get('roleId');
  }

  get dniControl() {
    return this.userForm.get('identificationNumber');
  }

  get nroTelControl() {
    return this.userForm.get('phoneNumber');
  }
}
